import React, { useEffect, useRef, useState } from "react";
import Counter from "./Counter";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrder,
  getPendingOrders,
  RESETORDER,
  selectOrder,
  selectOrderSuccess,
} from "../../redux/features/order/OrderSlice";
import { useNavigate } from "react-router-dom";
// import OrderDiscount from "./orderDiscount";
import dayjs from "dayjs";
import {
  getWaiters,
  selectWaiters,
} from "../../redux/features/waiter/WaiterSlice";
import { sendInvoiceToPrinter } from "../../Pages/Completing Order/kitchenPrint";

const Order = ({ order, setOrder, tableNo }) => {
  // order
  const handleQuantityChange = (index, newQuantity) => {
    const updatedOrderItems = order.map((item, i) =>
      i === index ? { ...item, quantity: newQuantity } : item,
    );
    setOrder(updatedOrderItems);
  };

  const handleDelete = (index) => {
    const updatedOrderItems = order.filter((item, i) => i !== index);
    setOrder(updatedOrderItems);
  };
  const handleCancel = () => {
    setOrder([]);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSuccess = useSelector(selectOrderSuccess);
  const currentOrder = useSelector(selectOrder);
  const serviceCharges = process.env.REACT_APP_SERVICE_CHARGES;
  const [waiter, setWaiter] = useState("");

  const orderData = {
    tableNo,
    orderNo: 0,
    products: [],
    totalAmount: 0,
    serviceCharges: 0,
    serviceChargesPercentage: serviceCharges,
    waiter: "",
  };

  const handleOrder = async () => {
    if (order.length === 0) {
      toast.error("Min 1 product required to place an order");
      return;
    }

    const now = new Date();
    const orderNo = Number(
      `${now.getDate() % 10}${now.getHours() % 10}${now.getMinutes() % 10}${now
        .getSeconds()
        .toString()
        .padStart(2, "0")}${now
        .getMilliseconds()
        .toString()
        .padStart(3, "0")
        .slice(0, 2)}`,
    );
    orderData.orderNo = orderNo;
    orderData.waiter = waiter;
    orderData.products = order;
    orderData.serviceCharges =
      serviceCharges > 0 ? (Number(total) / 100) * serviceCharges : 0;
    orderData.totalAmount = Number(total);
    await dispatch(createOrder(orderData));
  };

  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;

  const printRef = useRef();
  const printStyles = `
  @media print {
    body {
      margin: 0;
      padding: 0;
      
    }
    html, body {
      height: auto;
      width: 100%;
      overflow: hidden;
    }
    * {
      page-break-inside: avoid;
    }
    @page {
      size: auto; 
      margin: 0;
    }
  }
`;
  const handlePrint = async () => {
    const result = await sendInvoiceToPrinter(currentOrder);

    if (!result.success) {
      toast.error(result.message);
    } else {
      toast.success("Invoice printed successfully");
      return
    }

    const isMobile =
      /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      window.innerWidth < 768;

    if (isMobile) {
      const printContent = printRef.current.innerHTML;
      const win = window.open("", "_blank");

      win.document.write(`
      <html>
        <head>
          <title>Print Receipt</title>
          <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
          <style>
            @media print {
              body { padding: 20px; }
            }
          </style>
        </head>
        <body onload="window.print();">
          ${printContent}
        </body>
      </html>
    `);

      win.document.close();
    } else {
      const printContent = printRef.current;
      if (!printContent) return;

      const styles = Array.from(document.styleSheets)
        .map((sheet) => {
          try {
            return Array.from(sheet.cssRules)
              .map((rule) => rule.cssText)
              .join("\n");
          } catch (err) {
            return "";
          }
        })
        .join("\n");

      const iframe = document.createElement("iframe");
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
      <html>
        <head>
          <title>Print PDF</title>
         <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
        <style>
          ${styles}  
                    ${printStyles}

          body {
            font-family: 'Inter'; 
            color: #000;
            font-weight: medium;
          }
            .text-[.8rem]{
            font-size: 12px;
           
            }
            .text-[.7rem]{
            font-size: 11.2px;
           
            }
            .text-[.8rem]{
            font-size: 9.6px;
            
            }
        </style>
        </head>
        <body >${printContent.innerHTML}</body>
      </html>
    `);
      doc.close();

      iframe.contentWindow.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      };
    }
  };

  const total = order.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0,
  );
  useEffect(() => {
    if (!tableNo) {
      navigate("/tableNo");
    }
  }, [tableNo, navigate]);
  useEffect(() => {
    if (isSuccess) {
      handlePrint();
      handleCancel();
      navigate("/tableNo");
      dispatch(RESETORDER());
      dispatch(getPendingOrders());
    }
  }, [isSuccess, navigate]);

  const waiters = useSelector(selectWaiters);

  useEffect(() => {
    dispatch(getWaiters());
  }, [dispatch]);

  return (
    <div className="flex flex-col w-full justify-between relative ">
      <>
        <div className=" overflow-y-auto scrollbar-hide w-full  ">
          <div className="lg:mx-8 md:mx-4 mx-2 ">
            <div className=" sticky top-0 pt-1 bg-white mb-4">
              {tableNo && (
                <span className=" capitalize  text-[#0D868C] font-semibold">
                  Table No: {tableNo}
                </span>
              )}
              {waiters && (
                <select
                  value={waiter}
                  onChange={(e) => setWaiter(e.target.value)}
                  className="outline-none md:w-full w-[90%] py-2 border-2 mt-2  border-[#0D868C] rounded-lg font-semibold  capitalize text-[#0D868C]"
                >
                  <option value="">select waiter</option>
                  {waiters?.map((waiter, i) => (
                    <option key={i} value={waiter.waiterName}>
                      {waiter?.waiterName}
                    </option>
                  ))}
                </select>
              )}
            </div>

            {order.length > 0 ? (
              <ul className="mt-2">
                {order.map((product, index) => (
                  <li
                    key={index}
                    className={`flex items-center w-full lg:gap-6 md:gap-4 gap-2 py-2 ${
                      index !== 0 ? "border-t border-[#DEDEDE]" : ""
                    }`}
                  >
                    <div className="flex flex-col flex-1 ">
                      <h2 className="text-[#0D868C] text-[.8rem] lg:text-[1rem] font-semibold capitalize">
                        {product.name}{" "}
                      </h2>

                      <p
                        title={product.description}
                        className="text-[8px] lg:text-[10px] font-semibold capitalize text-[#A9A9A9]"
                      >
                        {product.description}
                      </p>
                    </div>
                    <div className="flex flex-col flex-1 items-end md:gap-2 gap-1">
                      <Counter
                        quantity={product.quantity}
                        onQuantityChange={(newQuantity) =>
                          handleQuantityChange(index, newQuantity)
                        }
                      />
                      <p className="text-[#1E1E1E] text-[.8rem] lg:text-[1rem]">
                        {product.price > 0 && (
                          <span>
                            {priceSymbol} {product.price * product.quantity}
                          </span>
                        )}
                      </p>
                    </div>
                    <div>
                      <button
                        className="text-red-500"
                        onClick={() => handleDelete(index)}
                      >
                        <MdDelete className="lg:size-6 size-4" />
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="capitalize mt-6 text-[#A9A9A9] lg:text-[1.5rem] text-wrap">
                no item in the order
              </p>
            )}
          </div>
        </div>
      </>
      <div>
        <div className="flex justify-between lg:mx-8 mx-4 items-center px-2 py-3 border-y-2 border-[#DEDEDE] my-4 relative">
          <span className="text-[.8rem] lg:text-[1rem] font-bold text-[#0D868C]">
            Total
          </span>
          <span className="text-[#1E1E1E] lg:text-[1rem] text-[.8rem]">
            {priceSymbol} {Number(total).toFixed(2)}
          </span>
        </div>
        <div className="flex justify-center items-center mb-5 lg:gap-10 gap-5">
          <button
            onClick={handleCancel}
            className="text-white bg-[#0D868C] text-[.8rem] lg:text-[1rem] font-bold md:w-[6rem] w-[5rem] lg:w-[9rem] md:p-3 p-1.5 rounded-full uppercase"
          >
            cancel
          </button>
          <button
            onClick={handleOrder}
            className="text-white bg-[#0D868C] text-[.8rem] lg:text-[1rem] font-bold md:w-[6rem] w-[5rem] lg:w-[9rem] md:p-3 p-1.5 rounded-full uppercase"
          >
            Order
          </button>
        </div>
      </div>
      <div className="hidden invisible">
        <div ref={printRef} className="flex justify-center items-center ">
          <div className=" m-1  bg-white  flex flex-col gap-.5">
            {/* order no */}

            <div className="w-full text-center space-y-1">
              <h1 className="text-[.8rem] uppercase tracking-[.1em] text-black">
                <p>Invoice #{currentOrder?.orderNo}</p>
              </h1>
              <h1 className="text-[.8rem] uppercase tracking-[.1em] text-black">
                <p>Table No #{currentOrder?.tableNo}</p>
              </h1>
            </div>

            <div className="flex justify-between items-center border-y border-[#0D868C] p-2">
              <p className="text-black text-[12px] uppercase tracking-[.1em] ">
                Waiter:{" "}
                <span className="uppercase tracking-[.1em]  text-[12px]">
                  {currentOrder?.username}
                </span>
              </p>
            </div>
            {/* Middle Section */}
            <div>
              {currentOrder?.products?.map((item, index) => (
                <div
                  key={item._id}
                  className={`flex items-start  w-full p-2 ${
                    index !== 0 ? "border-t border-[#0D868C]" : ""
                  }`}
                >
                  <div className="flex flex-col flex-1 gap-1 uppercase">
                    <h2 className="text-black text-[.7rem] uppercase tracking-[.1em]  ">
                      {item.name}{" "}
                    </h2>
                    {item?.name?.includes("deal") && (
                      <h2 className="text-black text-[.6rem] ">
                        {item?.description}{" "}
                      </h2>
                    )}
                  </div>
                  <div className="flex items-center justify-end w-[25%] text-black text-[.7rem] uppercase tracking-[.1em]  ">
                    <p className="">X{item.quantity}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Lower Section */}
            <div className="flex justify-center items-center text-black uppercase tracking-[.1em]   text-[14px] pb-6">
              <p>
                {dayjs(currentOrder?.createdAt).format("D /M /YYYY . h:mm A")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Order;
